import { render } from "./PaymentMethodsContent.vue?vue&type=template&id=452ca3b9&scoped=true"
import script from "./PaymentMethodsContent.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsContent.vue?vue&type=script&lang=js"

import "./PaymentMethodsContent.vue?vue&type=style&index=0&id=452ca3b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452ca3b9"]])

export default __exports__